<template lang="html">
  <ul class="date-prompt">
    <li>
      <em></em>
      <span>可预约</span>
    </li>
    <li>
      <em class="grey"></em>
      <span>不可预约</span>
    </li>
    <li>
      <em class="purple"></em>
      <span>今日</span>
    </li>
  </ul>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.date-prompt {
  display: flex;
  height: rem(80px);
  line-height: rem(80px);
  font-size: rem(28px);
  text-align: center;
  background: #fff;
  padding: 0 rem(33px);
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 rem(24px);
    em {
      display: inline-block;
      width: rem(24px);
      height: rem(24px);
      border-radius: 50%;
      margin-right: rem(16px);
      background-color: #121212;
      vertical-align: middle;
    }
    span {
      color: #333;
      font-size: rem(24px);
    }
    .grey {
      background-color: #ccc;
    }
    .purple {
      background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    }
  }
}
</style>
